import type { SectionItem } from "@/schema/resume/data";

import { TiptapContent } from "@/components/input/rich-input";
import { stripHtml } from "@/utils/string";
import { cn } from "@/utils/style";

import { LinkedTitle } from "../linked-title";
import { PageLink } from "../page-link";

type ProjectsItemProps = SectionItem<"projects"> & {
  className?: string;
};

export function ProjectsItem({ className, ...item }: ProjectsItemProps) {
  return (
    <div className={cn("projects-item", className)}>
      {/* Header */}
      <div className="section-item-header projects-item-header">
        {/* Row 1 */}
        <div className="flex items-start justify-between gap-x-2">
          <LinkedTitle
            title={item.name}
            website={item.website}
            showLinkInTitle={item.options?.showLinkInTitle}
            className="section-item-title projects-item-title"
          />
          <span className="section-item-metadata projects-item-period shrink-0 text-end">{item.period}</span>
        </div>
      </div>

      {/* Description */}
      <div
        className={cn("section-item-description projects-item-description", !stripHtml(item.description) && "hidden")}
      >
        <TiptapContent content={item.description} />
      </div>

      {/* Website */}
      {!item.options?.showLinkInTitle && (
        <div className="section-item-website projects-item-website">
          <PageLink {...item.website} label={item.website.label} />
        </div>
      )}
    </div>
  );
}
